import type { SearchClient } from "typesense";
import Typesense from "typesense";
import type Analytics from "typesense/lib/Typesense/Analytics";

export default defineNuxtPlugin<{
  typesenseClient: SearchClient | undefined;
  typesenseAnalyticsClient: Analytics | undefined;
}>(() => {
  const { apiKey, host, port, protocol, analyticsApiKey } =
    useRuntimeConfig().public.typesense;

  if (!apiKey || !host || !port || !protocol) {
    return {
      provide: {
        typesenseClient: undefined,
        typesenseAnalyticsClient: undefined,
      },
    };
  }

  const typesenseClient = new Typesense.SearchClient({
    nodes: [
      {
        host,
        port: Number(port),
        protocol,
      },
    ],
    apiKey,
    cacheSearchResultsForSeconds: 15,
    useServerSideSearchCache: true,
  });

  if (!analyticsApiKey) {
    return {
      provide: {
        typesenseClient,
        typesenseAnalyticsClient: undefined,
      },
    };
  }

  const client = new Typesense.Client({
    nodes: [
      {
        host,
        port: Number(port),
        protocol,
      },
    ],
    apiKey: analyticsApiKey,
  });

  const typesenseAnalyticsClient = client.analytics;

  return {
    provide: {
      typesenseClient,
      typesenseAnalyticsClient,
    },
  };
});
